<template>

    <div class="box height" :class="version=='v3'?'box height':'box height mt5'">
      <div class="left height" v-if="version=='v3' && !isbig"></div>
      <div class="middle height" style="overflow: hidden;text-overflow: ellipsis;">
        <div class="middleTop" v-if="version=='v3' && !isbig"></div>
        <div class="middleCon">
          <slot></slot>
        </div>
        <div class="middleBottom" v-if="version=='v3'"></div>
      </div>
      <div class="right height" v-if="version=='v3' && !isbig"></div>
    </div>

</template>
<script >
  export default {
    name: 'bg-yun',
    props:['isbig'],//isbig 是否为大图模式
    data () {
      return {
          version:'',
      };
    },
    methods:{

    },
    created(){
      if(window.location.href.indexOf('/orderv3')!=-1){ //老版本样式
          this.version = 'v3'
      }else{ //新版本样式
          this.version = 'v2'
      }
    }
  }
</script>
<style scoped>

  .box{
    display:flex;
    flex:1;
    flex-direction: row;
    justify-content: flex-start;
    background-color:#FDFCF8;
  }
  .mt5{
    margin-bottom: 5px;
  }

  .left{
    width:8px;
    background-image:url(hwLine-column.svg);
    background-repeat:repeat-y;
    background-size: 8px;
  }

  .middle{
    display:flex;
    flex:1;
    flex-direction: column;
    justify-content: space-around;
  }

  .middleTop{
    height:8px;
    background-image:url(hwLine-row.svg);
    background-repeat:repeat-x;
    background-size: 25px 8px;
  }

  .middleCon{
    flex:1;
    color:#7b663e;
    font-size:18px;
    overflow: hidden;
  }

  .middleBottom{
    height:8px;
    background-image:url(hwLine-row1.svg);
    background-repeat:repeat-x;
    background-size: 25px 8px;
  }

  .right{
    width:8px;
    background-image:url(hwLine-column1.svg);
    background-repeat:repeat-y;
    background-size: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/bg-yun/bgyun.vue